import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';

import { useQuery } from '@apollo/client/react';
import {
  Box,
  DropdownSingleSelect,
  IDropdownSingleSelectProps,
  Loader,
  Text,
} from '@opendoor/bricks/core';

import { ERROR_PAGE_ROUTE } from '../../src/routes/routes';
import {
  GET_MARKET_OPTIONS,
  IGetMarketOptions,
  IGetMarketOptionsVariables,
} from '../graphql/queries/GetMarketOptions';
// eslint-disable-next-line import/no-deprecated
import { UNSAFE_ISingleLineInputProps, UNSAFE_SingleLineInput } from './UNSAFE_SingleLineInput';

export type MarketOptionsProps = {
  marketIdentifier?: string;
  partnerIdentifier: string;
  onChange: IDropdownSingleSelectProps['onChange'];
  title: string;
  placeholder: string;
  isDisabled: boolean;
  otherMarketIdentifier?: string;
  onOtherChange: UNSAFE_ISingleLineInputProps['onChange'];
  partnerOptionsLoading: boolean;
};

type Option = {
  value: string;
  label: string;
};

const MarketOptions: React.FC<MarketOptionsProps> = (props: MarketOptionsProps) => {
  const [marketOptions, setMarketOptions] = useState(Array<Option>());

  const { loading, error, data } = useQuery<IGetMarketOptions, IGetMarketOptionsVariables>(
    GET_MARKET_OPTIONS,
    {
      variables: { identifier: props.partnerIdentifier },
    },
  );

  useEffect(() => {
    setMarketOptions(
      data?.partnerBranchesByIdentifier
        .filter((branch) => {
          return branch.marketActive;
        })
        .map((branch) => {
          return {
            value: branch.regionIdentifier,
            label: branch.marketDisplayName,
          };
        })
        .sort((a, b) => {
          return a.label > b.label ? 1 : -1;
        }) || [],
    );
  }, [data]);

  if (error) {
    return <Redirect to={ERROR_PAGE_ROUTE} />;
  }

  return props.partnerOptionsLoading ? null : (
    <Box marginBottom={7}>
      <Text as="label" id="market" fontWeight="bold" mb={2}>
        {props.title}
      </Text>
      {loading ? (
        <Loader />
      ) : (
        <>
          <DropdownSingleSelect
            aria-labelledby="market"
            allowOther={true}
            onChange={props.onChange}
            options={marketOptions}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
          />
          {props.marketIdentifier === 'other' && (
            <Box mt={2}>
              {/* eslint-disable-next-line react/jsx-pascal-case */}
              <UNSAFE_SingleLineInput
                name="other-market-input"
                placeholder={'Please specify'}
                content={props.otherMarketIdentifier}
                onChange={props.onOtherChange}
                unboundedWidth={true}
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default MarketOptions;
